import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, setAuthToken, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Wordmark, useBrand } from "@/context/BrandContext";
import { ShieldCheck, ShieldAlert } from "lucide-react";

export default function SsoLanding() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshWorkspace } = useAuth();
  const brand = useBrand();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("Missing SSO token."); return; }
    api.post("/sso/exchange", { token })
      .then((r) => {
        setAuthToken(r.data.token);
        refreshWorkspace?.(r.data.workspace);
        window.location.replace(params.get("next") || "/");
      })
      .catch((e) => { setAuthToken(null); setError(formatApiError(e)); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-white text-zinc-900 flex items-center justify-center p-8 tx-grid-bg" data-testid="page-sso">
      <div className="w-full max-w-md border border-zinc-200 bg-white p-8">
        <div className="flex items-center gap-2.5 mb-6">
          <Wordmark />
          <span className="tx-overline">single sign-on</span>
        </div>
        {error ? (
          <div data-testid="sso-error">
            <div className="flex items-center gap-2 text-rose-600 font-heading font-medium mb-2"><ShieldAlert className="w-5 h-5" /> Sign-in handoff failed</div>
            <p className="text-[13px] text-zinc-600 mb-4">{error}</p>
            <Link to="/login" className="font-mono text-[12px] text-orange-600 hover:underline" data-testid="sso-login-link">Sign in with email instead →</Link>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-zinc-700 font-mono text-[13px]" data-testid="sso-progress"><ShieldCheck className="w-4 h-4 text-orange-600" /> verifying {brand.source_app_name} sign-in token…</div>
        )}
      </div>
    </div>
  );
}
